import React from 'react';

export default function RichText({ heading, body }) {
  const lang = localStorage.getItem('language') || 'arm';
  const headingStr = heading ? (heading[lang] || heading.en || '') : '';
  const bodyStr    = body    ? (body[lang]    || body.en    || '') : '';

  return (
    <section className='rich-text-section main-container main-container-decoration'>
      <div className='description-banner'>
        {headingStr && <h2 className='title-generic'>{headingStr}</h2>}
        {bodyStr && (
          <div dangerouslySetInnerHTML={{ __html: bodyStr }} />
        )}
      </div>
    </section>
  );
}
